// src/pages/user/Messages.js
// Page messages utilisateur - NE PAS MODIFIER

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const Messages = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh' },
    header: {
      padding: '16px',
      position: 'sticky',
      top: 0,
      backgroundColor: '#0A0E1A',
      zIndex: 50,
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    },
    title: { fontSize: '22px', fontWeight: '700', color: '#FFFFFF' },
    emptyContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '64px 24px',
      textAlign: 'center',
      gap: '12px',
    },
    emptyIcon: { fontSize: '56px', opacity: 0.4 },
    emptyTitle: { fontSize: '16px', fontWeight: '600', color: '#FFFFFF' },
    emptyText: { fontSize: '14px', color: '#A0AEC0', maxWidth: '280px', lineHeight: '1.5' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Messages | Fynho</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <div style={styles.title}>💬 {t('nav.messages')}</div>
      </div>

      <div style={styles.emptyContainer}>
        <div style={styles.emptyIcon}>💬</div>
        <div style={styles.emptyTitle}>Aucun message</div>
        <div style={styles.emptyText}>
          Les échanges concernant vos réservations apparaîtront ici. Le contact avec les propriétaires se fait via WhatsApp.
        </div>
      </div>
    </div>
  );
};

export default Messages;